import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { ERROR_OK } from '~/constants/const-http';
import { useAsyncState } from '@vueuse/core';
import { computed, reactive, ref, useRoute } from "@nuxtjs/composition-api";
// import { months } from "dayjs";
import { omit } from "~/utils/helpers";
// import useRequest from "~/composables/useRequest";
import { getCruiseFilter } from "~/services/product";
import { useRouteQuery } from "@/composables/router";

type Item =
  | {
      value: string | number;
      label: string;
      id: string | number;
      name: string;
      type?: "item";
      // 字段名称用来在url 中记录
    }
  | {
      type: "title";
      label: string;
      id: string | number;
      value: string | number;
    };

export function useProductCruiseFilter(param: MaybeRefOrGetter<{
  home_port?: '1' | '0'
}>) {
  const searchData = reactive({
    keyword: useRouteQuery<string>('q'),
    cruise_route_first: useRouteQuery<string>("cruise_route_first"),
    route: useRouteQuery<string>("route"),
    month: useRouteQuery<string>("month"),
    brand: useRouteQuery<string>("brand"),
    cruise: useRouteQuery<string>("cruise"),
    country: useRouteQuery<string>("country"),
    city: useRouteQuery<string>("city"),
    day: useRouteQuery<string>("day"),
    tag: useRouteQuery<string>("tag"),
    cruise_type: useRouteQuery<string>("cruise_type"),
    sort_name: useRouteQuery<string>('sort_name', '1'),
    sort_type: useRouteQuery<string>('sort_type'),

    date_start: useRouteQuery<string>('date_start', ''),
    date_end: useRouteQuery<string>('date_end', ''),
  });
  // /product/product/cruise-date
  const { state, execute } = useAsyncState(
    async () => {
      let {
        day = '',
        month: travel_date
      } = searchData;
      const [min_day = '', max_day = ''] = day ? day.split('-') : ['', '']
      const {code, data, msg} = await getCruiseFilter({
        ...omit(searchData, ['srot_name', 'sort_type', 'day', 'month']),
        travel_date,
        day: {
          min: min_day,
          max: max_day
        },
        ...toValue(param)
      })
      if(code !== ERROR_OK){
        throw new Error(msg)
      }
      return data
    },
    {
      route: [],
      travel: [],
      cruise: [],
      port: [],
      days: [],
      tag: [],
      cruise_type: []
    },
    {
      immediate: false,
      resetOnExecute: false
    }
  );



  // const checkedCruiseRouteFirst = useRouteQuery('cruise_route_first', '');
  // const checkedRoute = useRouteQuery('route', '');
  // const months = useRouteQuery('months', '');
  // const brand = useRouteQuery('brand', '');

  const routes = computed(() =>
    state.value.route.map((item) => ({
      label: item.name,
      value: item.id,
      id: item.id,
      name: "cruise_route_first",
      children: item.list.map((item) => ({
        label: item.name,
        value: item.id,
        id: item.id,
        name: "route",
      })),
    }))
  );

  // const routes = ref([]);
  const $route = useRoute();
  const travelDates = computed(() => {
    return state.value.travel.reduce<Array<Item>>((result, item, index) => {
      result.push({
        label: item.year,
        type: "title",
        id: index,
        value: item.year,
      });
      item.month.forEach((m) => {
        result.push({
          type: "item",
          name: "month",
          value: m.id,
          id: m.id,
          label: `${m.name}月`,
        });
      });
      return result;
    }, []);
  });

  // 邮轮品牌
  const brands = computed(() =>
    state.value.cruise.map((item) => ({
      label: item.name,
      value: item.id,
      id: item.id,
      name: "brand",
      children: item.list.map((item) => ({
        label: item.name,
        value: item.id,
        id: item.id,
        name: "cruise",
      })),
    }))
  );

  const cities = computed(() =>
    state.value.port.map((item) => ({
      label: item.country,
      value: item.country_id,
      name: "country",
      id: item.country_id,
      children: item.list.map((item) => ({
        label: item.city,
        value: item.city_id,
        name: "city",
        id: item.city_id
      })),
    }))
  );

  const days = computed(() =>
    state.value.days.map((item) => ({
      label: item.value,
      name: "day",
      value: [item.gte, item.lte].join("-"),
    }))
  );

  const tags = computed(() => {
    const tags = state.value.tag.map((item ,index) => ({
      label: item.name,
      value: item.id,
      id: index,
      name: "tag",
    }))
    const types = state.value.cruise_type.map((item, index) => ({
      label: item.name,
      value: item.type,
      id: tags.length + index,
      name: 'cruise_type'
    }))

    return [...types, ...tags];
  });


  const dateRange = computed(() => [searchData.date_start, searchData.date_end])

  const labels = computed(() => {
    const {
      cruise_route_first,
      route,
      month,
      brand,
      cruise,
      country,
      city,
      day,
      tag,
      keyword,
      cruise_type
    } = searchData;
    const labels = [];

    if(keyword){
      labels.push({
        label: keyword,
        props: ['q']
      })
    }

    const checkedCruiseRouteFirst = routes.value.find(item => item.value === cruise_route_first);
    if(checkedCruiseRouteFirst){
      const checkedRoute = checkedCruiseRouteFirst.children.find(item => item.value === route)
      labels.push({
        label: [ checkedCruiseRouteFirst.label, checkedRoute?.label ].filter(v => !!v).join('/'),
        props: ['cruise_route_first', 'route'],
      })
    }
    const checkedMonth = travelDates.value.find(data => data.type !== 'title' && data.value === month);
    if(checkedMonth){
      labels.push({
        label: checkedMonth.label,
        props: ['month']
      })
    }

    const checkdBrand = brands.value.find(item => item.value === brand);
    if(checkdBrand){
      const checkedCruise = checkdBrand.children.find(item => item.value === cruise);
      labels.push({
        label: [ checkdBrand.label, checkedCruise?.label ].filter(v => !!v).join('/'),
        props: ['brand', 'cruise']
      })
    }


    const checkdCounty = cities.value.find(item => item.value === country);
    if(checkdCounty){
      const checkedCity = checkdCounty.children.find(item => item.value === city);
      labels.push({
        label: [ checkdCounty.label, checkedCity?.label ].filter(v => !!v).join('/'),
        props: ['country', 'city']
      })
    }

    const chekedDay = days.value.find(item => item.value === day);
    if(chekedDay){
      labels.push({
        label: chekedDay.label,
        props: ['day']
      })
    }

    // tags 计算属性是 tags 和 cruise_type 的合集 value 会有重复
    const chekedTag = state.value.tag.find(item => item.id === tag);
    if(chekedTag){
      labels.push({
        label: chekedTag.name,
        props: ['tag']
      })
    }
    // tags 计算属性是 tags 和 cruise_type 的合集 value 会有重复
    const checkedCruiseType = state.value.cruise_type.find(item => item.type === cruise_type)
    if(checkedCruiseType){
      labels.push({
        label: checkedCruiseType.name,
        props: ['cruise_type']
      })
    }


    if(searchData.date_start && searchData.date_end){
      labels.push({
        label: [searchData.date_start, searchData.date_end].map(v => v.replaceAll('-', '/')).join('-'),
        props: ['date_start', 'date_end']
      })
    }

    return labels.map(item => ({
      ...item,
      // searchData 和 route.query 中的参数并不一一对应 因此使用 query
      query: omit($route.value.query, [...item.props, 'page_index'])
    }));
  });

  return {
    state,
    routes,
    travelDates,
    brands,
    cities,
    days,
    tags,
    execute,

    searchData,

    labels,

    dateRange
  };
}
